import React from "react";

const SvgBBiconsNaposledyProhlizene = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <g id="Obecné_ikony" data-name="Obecné ikony">
        <g id="Naposledy_prohlizene" data-name="Naposledy prohlizene">
            <path d="M167.91,172.34a5,5,0,0,1-3.52-1.45L123,130a5,5,0,1,1,7-7.11l41.36,40.86a5,5,0,0,1-3.51,8.56ZM80.66,134.81A53.2,53.2,0,0,1,43,119.35h0a53.56,53.56,0,1,1,38,15.46Zm0-97.13A43.56,43.56,0,0,0,50,112.23h0a43.32,43.32,0,0,0,30.62,12.57h.27a43.57,43.57,0,0,0-.26-87.13Z"/>
            <path d="M80.66,47a34.26,34.26,0,1,0,34.26,34.26A34.26,34.26,0,0,0,80.66,47Zm17.63,54.12a4.71,4.71,0,0,1-3.35,1.39h0a4.71,4.71,0,0,1-3.36-1.39L76.78,86.3a4.7,4.7,0,0,1-1.35-2.94l0-.06V61.88a4.75,4.75,0,1,1,9.49,0V81l13.4,13.39A4.76,4.76,0,0,1,98.29,101.11Z"/>
        </g>
    </g>
  </svg>
);

export default SvgBBiconsNaposledyProhlizene;